import axios from 'axios';

const api = axios.create({
    baseURL: 'https://surfview.com.br',
    // baseURL: 'http://localhost:8000'
});


export async function login(email, password) {
    return await api.post('/api/authenticate', {
        email: email,
	    password: password
    })
}

export async function innerCamera(payload, config) {
    return await api.post('/api/cameras', payload, config)
}

export async function getAllCameras(config) {
    return await api.get('/api/cameras', config)
}

export async function getCameraId(idCam, config) {
    return await api.get(`/api/cameras/${idCam}`, config)
}

export async function deleteCamera( idCamera, config ) {
    return await api.delete(`/api/cameras/${idCamera}`, config)
}

export async function editCamera( idCamera, payload, config ) {
    return await api.put(`/api/cameras/${idCamera}`, payload, config)
}

    //ordenar Camera
    export async function orderCam(idRegion, payload, config) {
        return await api.post(`/api/cameras/${idRegion}/ordenar`, payload, config)
    }

//Regiões
export async function registerRegion(payload, config) {
    return await api.post('/api/areas-regioes', payload, config)
}

export async function getAllRegions(config) {
    return await api.get('/api/areas-regioes', config)
}

export async function deleteRegion( idRegion, config ) {
    return await api.delete(`/api/areas-regioes/${idRegion}`, config)
}

export async function editRegion( idRegion, payload, config ) {
    return await api.put(`/api/areas-regioes/${idRegion}`, payload, config)
}

    //ordenar regiao
    export async function orderRegion(payload, config) {
        return await api.post('/api/areas-regioes/ordenar', payload, config)
    }

//Videos
export async function insertVideoAnuncio(id_camera, formData, options, config) {
    return await api.post(`/api/cameras/${id_camera}/uploadVideo`, formData, config)
}

export async function deleteVideo( idCam, idVideo, config ) {
    return await api.delete(`/api/cameras/${idCam}/video/${idVideo}`, config)
}

//Images
export async function deleteImage( idCam, nameTagImage, config ) {
    return await api.delete(`/api/cameras/${idCam}/imagem/${nameTagImage}`, config)
}

//Cadastro de novos usuarios
export async function innerNewUser(payload, config) {
    return await api.post('/api/usuarios', payload, config)
}

export async function getListAll(config) {
    return await api.get('/api/usuarios', config)
}

export async function changeStatusUser(idUser, config) {
    return await api.get(`/api/usuarios/status/${idUser}`, config)
}

export async function updateUser(idUser, payload, config) {
    return await api.put(`/api/usuarios/${idUser}`, payload, config)
}

export async function getUserId(idUser, config) {
    return await api.get(`/api/usuarios/${idUser}`, config)
}

export async function deleteUserId(idUser, config) {
    return await api.delete(`/api/usuarios/${idUser}`, config)
}

    //Regionais
    export async function getListAllRegional(config) {
        return await api.get('/api/regionais', config)
    }

export async function listAllEstados(config) {
    return await api.get('/api/estados', config)
}

export async function orderingUf(payload, config) {
    return await api.post('/api/estados/ordenar', payload, config)
}

export default api